import { PublicAmendmentDetailProvider } from './context/public-amendment-detail-context';
import { PublicAmendmentDetailComponent } from './public-amendment-detail-component';

export function PublicAmendmentDetailFactory() {
    return (
        <PublicAmendmentDetailProvider>
            <PublicAmendmentDetailComponent />
        </PublicAmendmentDetailProvider>
    );
}
